"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderFolderType = void 0;
/**
 * 文件夹排序
 */
var OrderFolderType;
(function (OrderFolderType) {
    OrderFolderType[OrderFolderType["TIME_REVERSED"] = 0] = "TIME_REVERSED";
    OrderFolderType[OrderFolderType["TIME"] = 1] = "TIME";
    OrderFolderType[OrderFolderType["NAME"] = 2] = "NAME";
    OrderFolderType[OrderFolderType["NAME_REVERSED"] = 3] = "NAME_REVERSED";
    OrderFolderType[OrderFolderType["SIZE"] = 4] = "SIZE";
    OrderFolderType[OrderFolderType["SIZE_REVERSED"] = 5] = "SIZE_REVERSED";
})(OrderFolderType = exports.OrderFolderType || (exports.OrderFolderType = {}));
